import Polls from '../src/components/sections/Polls';

export default Polls;
